import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { EventRepeat as RecurringIcon } from "@mui/icons-material";
import DataTable from "../DataTable";
import { formatCurrency } from "../../utils/formatters";

const CATEGORY_LABELS = {
  rent: "Czynsz",
  utilities: "Media",
  insurance: "Ubezpieczenie",
  software: "Oprogramowanie",
  marketing: "Marketing",
  administrative: "Administracyjne",
  other: "Inne",
};

const FREQUENCY_LABELS = {
  monthly: "Miesięcznie",
  quarterly: "Kwartalnie",
  annual: "Rocznie",
  one_time: "Jednorazowo",
};

const ConstantCostsBreakdown = ({ breakdown, totalConstantCosts, isMobile }) => (
  <Paper sx={{ p: 3 }}>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
      <RecurringIcon sx={{ mr: 1 }} />
      Koszty stałe ({breakdown?.cost_details?.length || 0})
    </Typography>
    <Box sx={{ mb: 2, p: 2, bgcolor: '#fff3e0', borderRadius: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Okres: {breakdown.period_months?.toFixed(1)} miesięcy
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#e65100' }}>
        Łącznie: {formatCurrency(totalConstantCosts)}
      </Typography>
    </Box>

    {breakdown.by_category && Object.keys(breakdown.by_category).length > 0 && (
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          Według kategorii:
        </Typography>
        <Grid container spacing={1}>
          {Object.entries(breakdown.by_category).map(([category, amount]) => (
            <Grid item xs={6} sm={4} md={3} key={category}>
              <Box sx={{ p: 1.5, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  {CATEGORY_LABELS[category] || category}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {formatCurrency(amount)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    )}

    <DataTable
      size={isMobile ? "small" : "medium"}
      rows={breakdown.cost_details}
      getRowKey={(row, index) => index}
      emptyMessage="Brak kosztów stałych"
      columns={[
        {
          key: "name",
          label: "Nazwa",
          render: (row) => <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.name}</Typography>,
        },
        {
          key: "category",
          label: "Kategoria",
          render: (row) => (
            <Typography variant="body2" color="text.secondary">
              {CATEGORY_LABELS[row.category] || row.category || '-'}
            </Typography>
          ),
        },
        {
          key: "frequency",
          label: "Częstotliwość",
          render: (row) => (
            <Typography variant="body2" color="text.secondary">
              {FREQUENCY_LABELS[row.frequency] || row.frequency}
            </Typography>
          ),
        },
        {
          key: "base_amount",
          label: "Kwota bazowa",
          align: "right",
          render: (row) => <Typography variant="body2">{formatCurrency(row.base_amount)}</Typography>,
        },
        {
          key: "period_cost",
          label: "Koszt w okresie",
          align: "right",
          render: (row) => (
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#e65100' }}>
              {formatCurrency(row.period_cost)}
            </Typography>
          ),
        },
      ]}
    />
  </Paper>
);

export default ConstantCostsBreakdown;
